export default "__VITE_ASSET__BqFKGHW7__"